import React from 'react'

const SigninText = () => {
  return (
    <div className='signin-welcome-text'>Welcome to AgroEase</div>
  )
}

export default SigninText